import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import { VueGriddle } from "@braid/griddle";
import axios from "axios";
import router from "./router";

Vue.config.productionTip = false;

//HELPER
Vue.prototype.$http = axios;

//PLUGINS
import checkView from "vue-check-view";
Vue.use(checkView);

import { InlineSvgPlugin } from "vue-inline-svg";
Vue.use(InlineSvgPlugin);

import LottieAnimation from "./plugins/lottie/wrapper"; // import lottie-vuejs
Vue.use(LottieAnimation); // add lottie-animation to your global scope

//COMPONENTS
Vue.component("Griddle", VueGriddle);

//OBSERVER
Vue.prototype.$screen = Vue.observable({
  width: window.innerWidth,
  height: window.innerHeight,
  lastChange: 0,
});

window.addEventListener("resize", () => {
  Vue.prototype.$screen.lastChange = new Date().getTime();
  Vue.prototype.$screen.width = window.innerWidth;
  Vue.prototype.$screen.height = window.innerHeight;
});

//
Vue.prototype.$scroll = Vue.observable({
  x: window.scrollX,
  y: window.scrollY,
  lastChange: 0,
});

window.addEventListener("scroll", () => {
  Vue.prototype.$scroll.lastChange = new Date().getTime();
  Vue.prototype.$scroll.x = window.scrollX;
  Vue.prototype.$scroll.y = window.scrollY;
});

//SCREEN SIZE OBSERVER
Vue.prototype.$pointer = Vue.observable({
  x: 0,
  y: 0,
  lastChange: 0,
});

window.addEventListener("mousemove", (e) => {
  Vue.prototype.$pointer.lastChange = new Date().getTime();
  Vue.prototype.$pointer.x = e.pageX;
  Vue.prototype.$pointer.y = e.pageY;
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
